/**
 * Pagination Utilities
 *
 * Pure functions for pagination logic.
 */

/**
 * Calculate which page numbers to display with ellipsis.
 *
 * @param {number} current - Current page number
 * @param {number} total - Total number of pages
 * @returns {Array<number|string>} Page numbers and "..." placeholders
 */
export function getPagesToShow(current, total) {
  const pages = [];

  if (total <= 7) {
    for (let i = 1; i <= total; i++) {
      pages.push(i);
    }
  } else {
    pages.push(1);

    if (current > 3) {
      pages.push("...");
    }

    for (let i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i++) {
      if (!pages.includes(i)) {
        pages.push(i);
      }
    }

    if (current < total - 2) {
      pages.push("...");
    }

    pages.push(total);
  }

  return pages;
}
